export default __webpack_public_path__ + "static/media/instrucciones.baeb6225.pdf";